<template>
    获取用户信息失败,请稍后重试
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'TokenError',
});
</script>

<style scoped>

</style>
